import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TranslateModule } from '@ngx-translate/core';
import { OverlayPanelModule } from 'primeng-lts/overlaypanel';
import { DivisionDetailComponent } from './divisionDetail.component';
import { DossierBasicInfoModule } from './dossierBasicInfo.module';

@NgModule({
  declarations: [DivisionDetailComponent],
  imports: [
    TranslateModule,
    CommonModule,
    OverlayPanelModule,
    DossierBasicInfoModule
  ],
  exports: [DivisionDetailComponent]
})
export class DivisionDetailModule { }
